import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import { news } from "@/mocks/news";

export default function LatestNews() {
  const latest = news.slice(0, 6);
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <span className="font-label text-xs tracking-[0.3em] text-accent-600 uppercase">
            News
          </span>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950 mt-1">
            最新篮球资讯
          </h2>
        </div>
        <Link
          to="/news"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
        >
          全部资讯
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {latest.map((item) => (
          <NewsCard key={item.id} item={item} variant="grid" />
        ))}
      </div>

      <div className="mt-6 sm:hidden">
        <Link
          to="/news"
          className="w-full inline-flex items-center justify-center gap-1 px-5 py-3 rounded-md border border-background-300 text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
        >
          查看全部资讯
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
    </section>
  );
}